// extracted by mini-css-extract-plugin
export default {"links":"WorkerManagement_links__zgfH0"};